<template>
  <div class="new-order-form">
    <h4 class="tac">空間預約表單</h4>
    <p class="tac">您也可以<a href="/rooms" class="main_color">在此查詢</a>所有房間的預訂狀態</p>
    <div v-if="price !== ''" class="flex price-unit">
      <div class="fx1 tac">
        <span class="money">{{price}}</span> 元/時
        <p v-if="is_special_price"><span class="highlight">(所選日期有優惠。原價:{{o_price}}元)</span></p>
      </div>

    </div>
    <ValidationObserver class="validation posr" v-slot="{handleSubmit}">
      <div id="time-range-wrapper" class="flex flex_v_center">
        <time-range
          v-if="date !== null"
          :init_time="init_time"
          :finish_time="finish_time"
          :taken_orders="taken_orders"
          :selected_start_time="selected_start_time"
          :selected_end_time="selected_end_time"
        ></time-range>
      </div>
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="table-item flex flex_v_center" style="justify-content:flex-end;">
          <label class="fx1">空間選擇</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <select v-model="room_key" @change.prevent="changeRoom" class="form-control">
                <option v-for="room in rooms" :value="room.key" :key="room.key">{{room.title_and_ppl}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">選擇日期</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required" v-slot="{errors}">
                <datepicker
                  maximum-view="day"
                  v-model="date"
                  :language="zh"
                  :bootstrap-styling="true"
                  :format="dateFormat"
                  :disabled-dates="disabledDayRange"
                  placeholder="請選擇預訂日期..."
                  @selected="checkOrderDate"
                ></datepicker>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">開始時間</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required" v-slot="{errors}" name="start_time">
                <select v-model="selected_start_time" @change="changeStartTime" :disabled="date === null" class="form-control">
                  <option :value="null" selected disabled>請選擇開始時間</option>
                  <option v-for="(time, index) in selectable_start_times" :value="[index, time[1]]">{{time[0]}}</option>
                </select>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">結束時間</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required|endTimeCheck:@start_time" v-slot="{errors}">
                <select v-model="selected_end_time" :disabled="selected_start_time === null" class="form-control">
                  <option :value="null" selected disabled>請先選擇開始時間</option>
                  <option v-for="time in temp_selectable_end_times" :value="time[1]">{{time[0]}}</option>
                </select>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">聯絡人大名</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required" v-slot="{errors}">
                <input v-model="name" type="text" class="form-control" placeholder="請輸入您的大名...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">Email</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required|email" v-slot="{errors}">
                <input v-model="email" type="text" class="form-control" placeholder="您的電子郵件...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">手機號碼</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" :rules="{required: true, regex: /^09\d{8}$/}" v-slot="{errors}">
                <input v-model="cell" type="text" class="form-control" placeholder="請輸入手機號碼...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">備註說明</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <input v-model="comment" type="text" class="form-control" placeholder="例如請提供延長線...">
            </div>
          </div>
        </div>
        <div class="table-item flex flex_v_center">
          <label class="fx1">發票類型</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <select v-model="invoice_type">
                <option value="two">二聯式</option>
                <option value="three">三聯式</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="invoice_type === 'three'" class="table-item flex flex_v_center">
          <label class="fx1">公司發票抬頭</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" rules="required" v-slot="{errors}">
                <input v-model="invoice_title" type="text" class="form-control" placeholder="請輸入公司抬頭...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div v-if="invoice_type === 'three'" class="table-item flex flex_v_center">
          <label class="fx1">公司統一編號</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" :rules="{required: invoice_type === 'three', regex: /^\d{8}$/ }" v-slot="{errors}">
                <input v-model="unicode" type="text" class="form-control" placeholder="請輸入統一編號...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div v-if="invoice_type === 'three'" class="table-item flex flex_v_center">
          <label class="fx1">公司發票地址</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper">
              <ValidationProvider tag="div" class="validation posr" :rules="{required: invoice_type === 'three' }" v-slot="{errors}">
                <input v-model="invoice_address" type="text" class="form-control" placeholder="請輸入公司發票地址...">
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div v-if="name && cell && cell.length && email && duration >= 1" class="table-item flex flex_v_center">
          <label class="fx1">折價劵</label>
          <div class="fx3 form-group">
            <div class="date-range-inner-wrapper posr">
              <input v-model="coupon_no" type="text" class="form-control" placeholder="輸入折價劵號碼" @keyup.prevent="checkCoupon">
              <div v-if="coupon_response" class="coupon-response">{{coupon_response}}</div>
            </div>
          </div>
        </div>
        <!-- 訂單資訊 -->
        <div v-if="date && selected_start_time && selected_end_time && name && cell && email" class="table-item flex flex_v_start">
          <label class="fx1">訂單資訊</label>
          <div class="fx3">
            <ul class="order-info">
              <li>預訂日期時間: {{orderDateTime}}</li>
              <li>時間長度: {{duration}} 時</li>
              <li>預計金額: <span class="dollar">{{parseInt(price) * duration}}</span> 元</li>
              <li v-if="coupon_qualify">折抵金額: <span class="dollar">{{discount}}</span> 元</li>
              <li v-if="coupon_qualify">應付金額: <span class="dollar">{{(parseInt(price) * duration) - discount}}</span> 元</li>
            </ul>
          </div>
        </div>
        <!-- 必填 -->
        <div class="flex flex_v_center">
          <div class="fx1"></div>
          <div class="fx3">
            <ValidationProvider tag="span" class="validation posr" :rules="{ required: !confirm }" v-slot="{errors}">
              <label>
                <input type="checkbox" :checked="confirm" @change.prevent="confirm = !confirm">
                我瞭解需使用信用卡付款
              </label>
              <div class="error checkbox">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <div class="table-item flex flex_v_center mt20">
          <div class="form-btn w100p">
            <button type="submit" class="btn btn-orange w100p">預&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;訂</button>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <!-- fake form -->
    <form id="goToCheckout" class="none"></form>
  </div>
</template>
<script>
import {zh} from 'vuejs-datepicker/dist/locale';
import { format } from 'date-fns';
import addDays from 'date-fns/addDays';
// import subDays from 'date-fns/subDays';
import axios from 'axios';
import TimeRange from './time_range';
import { extend } from 'vee-validate';
import { required, regex, email, is } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';

extend('required', {
  ...required,
  message: '欄位為必填'
});

extend('is', {
  ...is,
  message: '必須勾選'
});

extend('email', {
  ...email,
  message: "請確認格式"
});

extend('regex', {
  ...regex,
  message: "欄位格式錯誤"
})

extend('endTimeCheck', {
  params: ['target'],
  validate(value, { target }) {
    // target是validation_providervid name="start_time"開始時間
    // console.log(value, target)
    return value > target[1];
  },
  message: '長度最少一小時'
})

export default {
  components: {TimeRange},
  props: ["selected_date", "start_time_index", "end_time_index", "rooms", "selected_room_key", "init_time", "finish_time", "price_unit", "default_selectable_start_times", "default_selectable_end_times", "default_orders", "all_time_scales", "all_end_time_scales", "origin_price", "has_special_price"],
  data: function() {
    return {
      room_key: this.selected_room_key || this.rooms[0].key,
      date: this.selected_date || null,
      zh: zh,
      disabledDayRange: {
        to: new Date(),
        from: addDays(new Date(), 91)
      },
      taken_orders: this.default_orders || [],
      selectable_start_times: this.default_selectable_start_times,
      selectable_end_times: this.default_selectable_end_times,
      temp_selectable_end_times: this.default_selectable_end_times || [],
      selected_start_time: this.start_time_index !== "" ? this.start_time_index.split(",").map(i => parseInt(i)) : null,
      selected_end_time: this.end_time_index !== "" ? parseInt(this.end_time_index) : null,
      price: this.price_unit,
      name: null,
      cell: null,
      email: null,
      comment: null,
      invoice_type: "two",
      invoice_title: null,
      invoice_address: null,
      unicode: null,
      confirm: false,
      coupon_no: "",
      coupon_qualify: false,
      coupon_response: null,
      discount: 0,
      o_price: this.origin_price,
      is_special_price: this.has_special_price || false
    }
  },
  computed: {
    orderDateTime() {
      const {room_key, date, selected_start_time, selected_end_time, all_time_scales, all_end_time_scales} = this;
      if (room_key && date && selected_start_time && selected_end_time) {
        let result = `${format(new Date(date), 'yyyy/MM/dd')} ${all_time_scales[selected_start_time[1]][0]}-${all_end_time_scales[selected_end_time][0]}`;
        return result;
      } else {
        return null;
      }
    },
    duration() {
      const {selected_start_time, selected_end_time} = this;
      if (selected_start_time && selected_end_time) {
        return (selected_end_time - selected_start_time[1] + 1) / 2;
      } else {
        return null;
      }
    }
  },
  methods: {
    dateFormat(date) {
      return format(date, 'yyyy/MM/dd')
    },
    checkOrderDate(date) {
      const url = '/api/orders/check_date_orders';
      const formattedDate = this.dateFormat(date);
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {
        date: formattedDate, key: this.room_key
      }).then((response) => {
        const {data} = response;
        // console.log(data);
        this.taken_orders = data.orders;
        this.selectable_start_times = data.selectable_start_times;
        this.selectable_end_times = data.selectable_end_times;
        this.selected_start_time = null;
        this.selected_end_time = null;
        this.price = data.price;
        this.o_price = data.origin_price;
        this.is_special_price = data.has_special_price;
      }).catch(error => console.log(error));
    },
    changeStartTime() {
      const [start_times_index, time_scale_index] = this.selected_start_time;
      let tempEndTime = [];
      this.temp_selectable_end_times = tempEndTime;
      for (let [i, j] = [start_times_index, 0]; i < this.selectable_start_times.length; i++, j++) {
        if (this.selectable_start_times[i][1] === time_scale_index + j) {
          tempEndTime.push(this.selectable_end_times[i])
        }
      }
      this.temp_selectable_end_times = tempEndTime;
      // 結束時間需重設
      this.selected_end_time = null;
    },
    checkCoupon() {
      const url = '/api/orders/check_coupon';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      const {coupon_no} = this;
      this.coupon_response = null;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      // 先關閉coupon_qualify
      this.coupon_qualify = false;
      // 檢查長度到5再發動
      if (coupon_no.length >= 5) {
        axios.post(url, {
          coupon_no,
          current_payment: parseInt(this.price) * this.duration
        }).then((response) => {
          const {data} = response;
          // console.log(data);
          this.coupon_response = data.message;
          if (data.status === 'ok') {
            this.coupon_qualify = true;
            this.discount = parseInt(data.coupon.discount);
          } else {
            this.coupon_qualify = false;
            this.discount = 0;
          }
        }).catch(error => console.log(error));
      }
    },
    changeRoom() {
      // 改變房間時也需要重設時間
      const {date} = this;
      const url = '/api/orders/check_date_orders';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      // 日期存在才觸發
      if (date) {
        axios.defaults.headers.common['X-CSRF-Token'] = csrf;
        axios.post(url, {
          date, key: this.room_key
        }).then((response) => {
          const {data} = response;
          this.taken_orders = data.orders;
          this.selectable_start_times = data.selectable_start_times;
          this.selectable_end_times = data.selectable_end_times;
          this.selected_start_time = null;
          this.selected_end_time = null;
          this.price = data.price;
          this.o_price = data.origin_price;
          this.is_special_price = data.has_special_price;
        }).catch(error => console.log(error));
      }
    },
    onSubmit() {
      // console.log("create")
      const {room_key, date, selected_start_time, selected_end_time, name, cell, email, comment, invoice_type, invoice_title, invoice_address, unicode, coupon_no} = this;
      const url = '/orders';
      const csrf = document.head.querySelector("meta[name=csrf-token]").content;
      axios.defaults.headers.common['X-CSRF-Token'] = csrf;
      axios.post(url, {
        room_key,
        date,
        start_time: selected_start_time[1],
        end_time: selected_end_time,
        name,
        cell,
        email,
        comment,
        invoice_type,
        invoice_title,
        invoice_address,
        unicode,
        coupon_no
      }).then((response) => {
        const {data} = response;
        // console.log(data);
        if (data.status === 'ok') {
          const order_key = data.order_key;
          Swal.fire({
            title: '空間已保留',
            text: data.message,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '確認付款',
            cancelButtonText: '取消'
          }).then((result) => {
            if (result.value) {
              // 轉到付款頁, 先建立虛擬form再透過form轉
              const url = `/orders/${order_key}/checkout`;
              const form = $("form#goToCheckout");
              const form_token = $("input").attr('type', 'text').attr('name', 'authenticity_token').attr('value', csrf);
              form.attr('action', url);
              form.attr("method", "POST");
              form.append(form_token);
              form.submit();
            }
          })
        } else {
          // console.log(data.message)
          Swal.fire({
            title: '訂單錯誤！',
            text: data.message,
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: '再次嘗試'
          })
        }
      }).catch(error => console.log(error));
    }
  },
  created() {
    if (this.selected_start_time) {
      const [start_times_index, time_scale_index] = this.selected_start_time;
      let tempEndTime = [];
      this.temp_selectable_end_times = tempEndTime;
      for (let [i, j] = [start_times_index, 0]; i < this.selectable_start_times.length; i++, j++) {
        if (this.selectable_start_times[i][1] === time_scale_index + j) {
          tempEndTime.push(this.selectable_end_times[i])
        }
      }
      this.temp_selectable_end_times = tempEndTime;
    }
  }
}
</script>
<style>
  span.cell.day-header {
    margin-top: 40px;
  }
  .vdp-datepicker__calendar header {
    display: flex !important;
    align-items: center;
  }
  .vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next{
    flex: 1;
  }
  .banner-form.form-style-2 .table-item span  {
    right: 0
  }
  .vdp-datepicker__calendar .cell.day-header {
    background-color: white !important;
  }
  .vdp-datepicker__calendar .cell.day {
    background: #d5f0f8;
  }

  .vdp-datepicker__calendar .cell.day.disabled, .vdp-datepicker__calendar .cell.day.blank {
    background-color: white !important;
    color: #bfbfbf !important;
    text-decoration: line-through;
  }
  form .posr .error.checkbox {
    top: -9px;
    right: -80px;
  }

  .coupon-response {
    position: absolute;
    top: 12px;
    right: 20px;
    font-size: 14px;
    z-index: 2;
  }
  ul.order-info li {
    font-size: 14px;
  }

  .new-order-form .bar {
    margin-bottom: 30px;
  }

  /* 上方顯示金額區 */
  .price-unit {
    margin-bottom: 10px;
  }
  .price-unit .money {
    font-size: 2.15em;
  }

  span.dollar {
    color: #2aacaf;
    font-size: 1.45em;
    font-weight: 600;
  }

</style>